import { RiListCheck3 } from '@remixicon/react';

import { createToolExtension } from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

export const TodoWriteToolExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'todo-write',
    predicate: tool => tool === 'TodoWrite' || tool.endsWith('__TodoWrite'),
    icon: RiListCheck3,
    display: 'grouped',
    render: () => null,
    renderTool: () => null,
  }),
);
